export default __webpack_public_path__ + "static/media/arctradeLogo_icon.ea678977.png";